import type { CardProps } from "@karrtopelka/cards/types";
import {
  minesBustProvocation,
  minesProvocation,
} from "@karrtopelka/cards/provocations";

/** Win card: the cashed multiplier. */
export function buildMinesCard(
  mult: number,
  value: number,
  handle: string,
  submit: { total: number; percentile: number } | null,
): CardProps {
  const props: CardProps = {
    game: "mines",
    display: `${mult.toFixed(2)}x`,
    handle,
    provocation: minesProvocation(value),
    date: new Date().toISOString().slice(0, 10),
  };
  if (submit && submit.total >= 10) {
    props.rankLine = `top ${submit.percentile}% today`;
  }
  return props;
}

/** Bust card: posting the boom (the L is the joke). */
export function buildMinesBustCard(gems: number, handle: string): CardProps {
  return {
    game: "mines",
    display: "BOOM",
    handle,
    provocation: minesBustProvocation(gems),
    date: new Date().toISOString().slice(0, 10),
  };
}
